import React from 'react';
import PropTypes from 'prop-types';
import { useFormControl } from '../FormControl/FormControl.context';

import * as Styled from './FormInputLimit.styled';

/**
 * `FormInputLimit` is used to display a count / limit of characters in a `TextArea`
 *  It uses state from `FormControl`.
 */
const FormInputLimit = ({ limit }) => {
  const formContext = useFormControl();
  const { value } = formContext.inputProps;
  const count = !value ? 0 : value.length;

  return (
    <Styled.Limit
      data-testid="FormInputLimit"
      isEmpty={formContext.isEmpty}
      isFocused={formContext.isFocused}
    >
      {count} / {limit}
    </Styled.Limit>
  );
};

FormInputLimit.propTypes = {
  /**
   * Character limit
   */
  limit: PropTypes.number.isRequired
};

export default FormInputLimit;
